// Environment Configuration - 直接从环境变量读取
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

// 从环境变量获取配置，提供合理的默认值
const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
    PRODUCT_ID: process.env.REACT_APP_PRODUCT_ID || '9500',
    PROXY: process.env.REACT_APP_PROXY || '',
    ENV: ENV
};

// 开发环境特殊处理
if (ENV === 'development' && !config.PROXY) {
    config.PROXY = 'http://localhost';
}

// 辅助函数
export const getEnv = () => config.ENV;
export const getApiBaseUrl = () => config.API_BASE_URL;
export const getProductId = () => config.PRODUCT_ID;
export const getProxy = () => config.PROXY;

// 导出整个配置对象
export const getConfig = () => config;

// 导出默认配置
export default config;